require('../utils/checkIsLoggedIn.js');
require('./enable_tracking.js');
require('./handle_developer_mode.js');
require('../utils/setUpButtons.js');
require('./accordions.js');
require('./appLinks.js');
require('./setDownloadButtonData.js');
require('./open_support.js');
require('./sidemenu.js');
require('./slider.js');
require('./translates.js');
require('./images_src_by_key.js');
require('./handle_links.js');
require('./setViewport.js');
require('./handle_gtag_events.js');
require('./popups/open_signup_form_timeout.js');
require('./handle_gamification_special_links.js');

require('./popups/activate_forms.js');
require('./popups/couponClick.js');
require('./popups/customSelect.js');
require('./popups/forgotPass.js');
require('./popups/input.js');
require('./popups/toggle.js');
